/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DisableHubspotInput = {|
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type DisableHubspotMutationVariables = {|
  input: DisableHubspotInput
|};
export type DisableHubspotMutationResponse = {|
  +disableHubspot: ?{|
    +company: ?{|
      +hubspotAccountId: ?string
    |}
  |}
|};
export type DisableHubspotMutation = {|
  variables: DisableHubspotMutationVariables,
  response: DisableHubspotMutationResponse,
|};
*/


/*
mutation DisableHubspotMutation(
  $input: DisableHubspotInput!
) {
  disableHubspot(input: $input) {
    company {
      hubspotAccountId
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DisableHubspotInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hubspotAccountId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DisableHubspotMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DisableHubspotPayload",
        "kind": "LinkedField",
        "name": "disableHubspot",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DisableHubspotMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DisableHubspotPayload",
        "kind": "LinkedField",
        "name": "disableHubspot",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "DisableHubspotMutation",
    "operationKind": "mutation",
    "text": "mutation DisableHubspotMutation(\n  $input: DisableHubspotInput!\n) {\n  disableHubspot(input: $input) {\n    company {\n      hubspotAccountId\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '563e3234041e32dea5192c87319a50ea';

module.exports = node;
